import React, { useEffect, useState } from 'react';
import { Button, Grid, TextField, Typography } from '@mui/material';
import EtabInfosTable from '../../../components/table/admin/etab-infos/etab-infos.table';
import { EtabInfosPaginationDto } from '../../../services/dtos/etab-infos-pagination.dto';
import { getEtablissements } from '../../../services/etablissement-information.service';
import { env } from '../../../env';
import LinearProgress from '@mui/material/LinearProgress';

/**
 * Page de moteur de recherche
 * @constructor
 */
export default function InformationEtablissementPage() {
    //UseState
    const [page, setPage] = useState<number>(0);
    const [searching, setSearching] = useState<boolean>(false);
    const [etablishments, setEtablishments] = useState<EtabInfosPaginationDto>();
    const [etablishmentSearch, setEtablishmentSearch] = useState<string>('');

    const rowsPerPage = Number(env.REACT_APP_NUMBER_ELEMENT_TABLE);

    //Permet de changer de page
    const handleSwitchPageNumber = (pageNumber: number) => {
        setPage(pageNumber);
    };

    useEffect(() => {
        setSearching(true);
        getEtablissements(etablishmentSearch, page + 1, rowsPerPage)
            .then(datas => {
                setEtablishments(datas);
            })
            .finally(() => {
                setSearching(false);
            });
    }, [page, etablishmentSearch, rowsPerPage]);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault(); // Ceci est tout à fait valide en TypeScript
        const formData = new FormData(event.currentTarget);
        const designation = formData.get('etablissement');
        setEtablishmentSearch((designation as string) || '');
    };

    //Affichage de la page
    return (
        <>
            <Typography variant="h5">Recherche d'établissement</Typography>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2} className="search-user-form" direction={'row'} alignItems={'center'}>
                    <Grid item xs={5}>
                        <TextField id="etablissement" name="etablissement" label="Etablissement" />
                    </Grid>
                    <Grid item sm={5}>
                        <Typography variant={'button'} className={'buttons-form'}>
                            <Button type="submit" variant="contained">
                                Rechercher
                            </Button>
                        </Typography>
                    </Grid>
                </Grid>
            </form>
            <Typography variant="h5">Visibilité des établissements</Typography>
            <Grid container spacing={2} direction="column">
                <Grid item>
                    {etablishments && !searching && (
                        <EtabInfosTable
                            etablishments={etablishments}
                            searching={searching}
                            handleSwitchPageNumber={handleSwitchPageNumber}
                            page={page}
                        />
                    )}
                    {searching && <LinearProgress />}
                </Grid>
            </Grid>
        </>
    );
}
